import { render, staticRenderFns } from "./CompanyRegisterJWT.vue?vue&type=template&id=247cbbf0&scoped=true"
import script from "./CompanyRegisterJWT.vue?vue&type=script&lang=js"
export * from "./CompanyRegisterJWT.vue?vue&type=script&lang=js"
import style0 from "./CompanyRegisterJWT.vue?vue&type=style&index=0&id=247cbbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cbbf0",
  null
  
)

export default component.exports